import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import emptyFunction from '@avtechsoftware/ra-javascript-utilities/src/utilities/EmptyFunction';

function FormButtonGroup({
  onSubmit,
  onCancel,
  submitBtnText,
  disabled,
  isSubmitting,
  buttonType,
  redirectLink,
  loadingBtnText,
}) {
  return (
    <div className="py-3">
      <hr />
      <div className="my-3 d-flex row justify-content-center">
        <div>
          {/* eslint-disable-next-line react/button-has-type */}
          <button
            type={buttonType}
            disabled={disabled || isSubmitting}
            className="btn btn-primary mr-1"
            id="submit-form-button"
            onClick={onSubmit}
          >
            {isSubmitting ? loadingBtnText : submitBtnText}
          </button>
          <Link to={redirectLink}>
            {/* eslint-disable-next-line react/button-has-type */}
            <button
              type={buttonType}
              onCancel={onCancel}
              className="btn btn-light border-1"
              style={{ borderColor: '#ccc' }}
            >
              Cancel
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
FormButtonGroup.defaultProps = {
  onSubmit: emptyFunction,
  onCancel: emptyFunction,
  submitBtnText: 'Submit',
  disabled: false,
  isSubmitting: false,
  buttonType: 'button',
  redirectLink: '#',
  loadingBtnText: 'Submitting...',
};
FormButtonGroup.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  submitBtnText: PropTypes.string,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  buttonType: PropTypes.string,
  redirectLink: PropTypes.string,
  loadingBtnText: PropTypes.string,
};
export default FormButtonGroup;
